import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
// Huisstijl van de website voor de ingelogde webapp + app: bewust NA App
// geïmporteerd, zodat deze stijlen de oudere dashboardstijlen overschrijven.
import './publicTheme.css';
import './appTheme.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Laat de browser NOOIT zelf de scrollpositie "herstellen" bij een herlaad.
// Zijn eigen herstel-logica combineert slecht met de sticky navbar
// (Chromium-bug: scroll-anchoring telt een "position: sticky"-element soms
// dubbel mee), waardoor je bij elk opeenvolgend herlaad een stukje verder
// naar onder in de pagina belandde i.p.v. gewoon terug bovenaan. Met
// "manual" bepalen wij zelf de scrollpositie (altijd bovenaan bij een
// gewone paginalaad, zie ook overflow-anchor: none op .navbar).
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registreert de service worker zodat SmartStays installeerbaar is als PWA
// ("Voeg toe aan beginscherm"). API-aanroepen worden niet gecachet, dus
// gegevens blijven altijd live.
//
// Zonder "onUpdate" hieronder blijft een nieuwe build na het deployen
// onzichtbaar "wachten" op de service worker, tot alle open tabbladen/de
// PWA volledig gesloten zijn - waardoor gebruikers een oude versie konden
// blijven zien, ook na een geslaagde deploy. Met "onUpdate" activeren we de
// nieuwe versie meteen (SKIP_WAITING, al voorzien in service-worker.js) en
// herladen we de pagina automatisch éénmalig zodra ze klaarstaat.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    if (!window.__smartstaysReloading) {
      window.__smartstaysReloading = true;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }
  },
  // De browser checkt zelf ook op nieuwe service-worker-versies, maar doet
  // dat sterk gethrottled (tot 24u tussen checks) - bij meerdere deploys op
  // 1 dag bleef een open/eerder bezocht tabblad daardoor soms lang op een
  // oude, kapotte versie hangen zonder dat "onUpdate" hierboven ooit
  // getriggerd werd. Forceert daarom zelf een verse check telkens het
  // tabblad weer actief wordt (terugkeer na wisselen van tab/app, scherm
  // aanzetten, enz.), zodat een update nooit langer dan nodig blijft
  // "wachten".
  onRegister: (registration) => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        registration.update().catch(() => {});
      }
    });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();